import { Box, Paper, ClickAwayListener } from "@mui/material";
import PropTypes from "prop-types";

const CustomTooltip = ({ open, onClose, title, children }) => (
  <ClickAwayListener onClickAway={onClose}>
    <Box sx={{ position: "relative", display: "inline-block" }}>
      {children}
      {open && (
        <Paper
          sx={{
            position: "absolute",
            bottom: "100%",
            left: "50%",
            transform: "translateX(-50%)",
            mb: 1,
            p: 1.5,
            minWidth: 280,
            maxWidth: 350,
            fontSize: "0.85rem",
            zIndex: 1500,
            bgcolor: "rgba(50, 50, 50, 0.9)",
            color: "white",
            borderRadius: 1,
            "&::after": {
              content: '""',
              position: "absolute",
              top: "100%",
              left: "50%",
              transform: "translateX(-50%)",
              borderLeft: "6px solid transparent",
              borderRight: "6px solid transparent",
              borderTop: "6px solid rgba(50, 50, 50, 0.9)",
            },
          }}
        >
          {title}
        </Paper>
      )}
    </Box>
  </ClickAwayListener>
);

CustomTooltip.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

export default CustomTooltip;
